import React from 'react';

interface INotDueIcon{
  width?:string;
  height?:string;
  colorStyle?:any;
}
const NotDueIcon = ({ width, height, colorStyle }:INotDueIcon) => (
  <svg width={width || '22'} height={height || '22'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="11" fill={colorStyle?.fill || '#F2F4F7'} />
    <path d="M12.333 13.312V16H9.46301V13.312H12.333ZM12.473 5.878L11.759 12.374H10.093L9.32301 5.878H12.473Z" fill={colorStyle?.path || '#555555'} />
  </svg>

);
export default NotDueIcon;
